import { connect } from 'react-redux';
import { selectIsAppLoading } from 'Favourites/store/reducers';

const mapStateToProps = (state) => {
    return {
        isLoading: selectIsAppLoading(state),
    };
};

export default connect(mapStateToProps);
